import { useEffect } from "react";

export const useViewportHeightVar = () => {
  useEffect(() => {
    let previousWidth = window.innerWidth;

    const setHeight = () => {
      document.documentElement.style.setProperty(
        "--app-height",
        `${window.innerHeight}px`
      );
    };

    const handleResize = () => {
      const currentWidth = window.innerWidth;
      // Mobile browsers fire resize when the address bar hides/shows on scroll,
      // changing only innerHeight — ignore those to avoid a growth feedback loop.
      if (currentWidth === previousWidth) {
        return;
      }
      previousWidth = currentWidth;
      setHeight();
    };

    setHeight();
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", setHeight);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", setHeight);
    };
  }, []);
};
